import { Shimmer } from '../styles';

export const InputLoader = ({ height = '56px' }) => {
  return (
    <div>
      <Shimmer style={{ height: height }}></Shimmer>
    </div>
  );
};
